"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = require("../../../../../components/Button");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Button = function Button(props) {
  return /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    variantStyle: "solid",
    variantColor: "primary",
    type: "submit"
  }, props.children);
};

exports.Button = Button;